<div class="progressBar">
  <mat-progress-bar [value]="progress$ | async" class="player-progress" disabled></mat-progress-bar>
</div>
<!--
  TODO :: isSpotify to discuss
-->
<div [ngClass]="{'isSpotify': isSpotify}" class="player-container player-container-{{ playerClass }}">

  <div class="button-play">
    <mwo-play-btn [disabled]="isSoundMessage"></mwo-play-btn>
  </div>

  <div class="volume">

    <mwo-button [svgIcon]="'mwo-speaker'" [disable]="isSourcesDisabled || isSoundMessage" *ngIf="!isSourcesDisabled"
      [active]="(isPlaying$ | async)" (onClick)="openSonos()"></mwo-button>

    <mwo-button *ngIf="!isDesktop" [svgIcon]="'mwo-playback'" [active]="isPlaybackActivated"
      (onClick)="playbackDisplay()"></mwo-button>

    <!--Before dispalayVolume variable for is active, in the long run, check the variable on the component side to see if it is useless.-->
    <mwo-button (onClick)="volumeDisplay()" [active]="displayVolume" [svgIcon]="'mwo-volume'"></mwo-button>

  </div>
  <div class="controls desktop">
    <div class="top-controls">

      <!--
      Dislike and favorite display two compoments
      I guess that those two blocks could be refactor into one.
      However before the refactoring, I am not sure why they did that,
      that why at the moment I advise to keep both of them
      But in the long run, I guess it could be simplified-->

      <div class="mwo-btn-group like-group">
        <mwo-button [svgIcon]="'mwo-like'" *ngIf="(isInWishlist$ | async)" [payload]="currentMedia$ | async"
          [disable]="!(isInWishlist$ | async) || isSoundMessage" [active]="true"
          (onClick)="unlike($event)"></mwo-button>

        <mwo-button [svgIcon]="'mwo-like'" *ngIf="!(isInWishlist$ | async)" [payload]="currentMedia$ | async"
          [disable]="(isInWishlist$ | async) || isSoundMessage" [active]="false" (onClick)="like($event)"></mwo-button>

        <mwo-button [svgIcon]="'mwo-dislike'" *ngIf="(isInBlacklist$ | async)" [payload]="currentMedia$ | async"
          [disable]="!(isInBlacklist$ | async) || isSoundMessage" [active]="true"
          (onClick)="unBlacklist(event$)"></mwo-button>

        <mwo-button [svgIcon]="'mwo-dislike'" *ngIf="!(isInBlacklist$ | async)" [payload]="currentMedia$ | async"
          [disable]="(isInBlacklist$ | async) || isSoundMessage" [active]="false"
          (onClick)="blacklist($event)"></mwo-button>
      </div>

      <div class="mwo-btn-group next-group">
        <mwo-button [svgIcon]="'mwo-next'" [disable]="isSoundMessage" [active]="false" (onClick)="next()"></mwo-button>
        <!-- The bellow div is here only to take the same space at the real one. this to ensure that btn is at the same distance of the play btn.
          This until a real refacto occurs -->
        <div class="" style="width: 48px; height: 48px;"></div>
      </div>

    </div>


  </div>

  <!-- This block is only display for mobile format-->
  <div class="controls mobile">
    <div class="top-controls">
      <div class="left">
        <mwo-button *ngIf="!isDesktop" [svgIcon]="'mwo-playback'" [active]="isPlaybackActivated"
          (onClick)="playbackDisplay()"></mwo-button>
      </div>
      <div class="right">
        <mwo-button [svgIcon]="'mwo-next'" [disable]="isSoundMessage" [active]="false" (onClick)="next()"></mwo-button>
        <div class="mwo-btn-group">
          <mwo-button [svgIcon]="'mwo-speaker'" [disable]="isSourcesDisabled || isSoundMessage"
            *ngIf="!isSourcesDisabled" [active]="(isPlaying$ | async)" (onClick)="openSonos()"></mwo-button>
          <mwo-button (onClick)="volumeDisplay()" [active]="displayVolume" [svgIcon]="'mwo-volume'"></mwo-button>
        </div>

      </div>
      <div class="button-play">
        <mwo-play-btn></mwo-play-btn>
      </div>
    </div>
  </div>
  <div class="cover">
    <div class="footer-container">
      <img *ngIf="showHearts" alt="Hearts like animation" class="hearts" src="/assets/icons/like.gif" />
      <div class="cover-img">
        <img [src]="coverUrl" alt="Setlist Icon" class="player-cover" />
      </div>
      <div class="title-container">
        <div [class.overflow]="isTitleOverflowing" class="container">
          <div>{{ songTitle || ("player.noMedia" | translate) }}</div>
        </div>
        <div [class.overflow]="isArtistOverflowing" class="container artist-color">
          <div>{{ artist || '' }}</div>
        </div>
      </div>
    </div>
    <div class="footer-container like-group mwo-btn-group">

      <mwo-button [svgIcon]="'mwo-like'" *ngIf="(isInWishlist$ | async)" [payload]="currentMedia$ | async"
        [disable]="!(isInWishlist$ | async) || isSoundMessage" [active]="true" (onClick)="unlike($event)"></mwo-button>

      <mwo-button [svgIcon]="'mwo-like'" *ngIf="!(isInWishlist$ | async)" [payload]="currentMedia$ | async"
        [disable]="(isInWishlist$ | async) || isSoundMessage" [active]="false" (onClick)="like($event)"></mwo-button>

      <mwo-button [svgIcon]="'mwo-dislike'" *ngIf="(isInBlacklist$ | async)" [payload]="currentMedia$ | async"
        [disable]="!(isInBlacklist$ | async) || isSoundMessage" [active]="true"
        (onClick)="unBlacklist(event$)"></mwo-button>

      <mwo-button [svgIcon]="'mwo-dislike'" *ngIf="!(isInBlacklist$ | async)" [payload]="currentMedia$ | async"
        [disable]="(isInBlacklist$ | async) || isSoundMessage" [active]="false"
        (onClick)="blacklist($event)"></mwo-button>

    </div>
  </div>
</div>
